export default function Testimonials() {
  const testimonials = [
    {
      name: 'Michael Rodriguez',
      company: 'Tech Innovations Inc.',
      text: 'The corporate video they produced exceeded our expectations. Professional, creative, and delivered on time. Our stakeholders were incredibly impressed.',
      rating: 5
    },
    {
      name: 'Sarah Chen',
      company: 'Coastal Real Estate',
      text: 'Their real estate videos have transformed how we market properties. The drone footage and editing quality are outstanding. Sales have increased significantly.',
      rating: 5
    },
    {
      name: 'David Thompson',
      company: 'Summit Marketing Group',
      text: 'Working with this team on our promotional videos has been fantastic. They understand our brand and consistently deliver engaging content that resonates with our audience.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by businesses across Long Island
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#1E3A8A]"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>
              <div>
                <div className="font-bold text-gray-900">
                  {testimonial.name}
                </div>
                <div className="text-sm text-gray-600">
                  {testimonial.company}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}